import { AppContainer } from 'react-hot-loader';
import React from 'react';
import { render } from 'react-dom';

import Routes from './routes';

const app = document.getElementById('locator-app');

render(
	<AppContainer>
		<Routes />
	</AppContainer>,
	app,
);

/* eslint-disable global-require */
if (module.hot) {
	module.hot.accept('./routes', () => {
		const NextApp = require('./routes').default;
		render(
			<AppContainer>
				<NextApp />
			</AppContainer>,
			app,
		);
	});
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/index.js